module.exports = __webpack_public_path__ + "img/corneal-infiltrates-1.78f7bb3f.jpg";